import Guid from "~/helpers/guid";
import Vue from "vue";
import PaymentLineItem from "./paymentLineItem";
import WorkflowStep from "../workflow/workflowStep";
import {PaymentLineItemType} from "./paymentLineItemType";
import PaymentLineItemAmountFactory from "./paymentLineItemAmountFactory";

export default class PaymentLineItemFactory {
  constructor() {

  }

  static create(workflowStep: WorkflowStep, json: object, isAttached: boolean = false, isNew: boolean = false): PaymentLineItem {
    const paymentLineItem: PaymentLineItem = new PaymentLineItem();

    paymentLineItem.rootModel = workflowStep.rootModel;
    paymentLineItem.defineProperty('client_id', json['client_id'] || Guid.create());
    paymentLineItem.defineProperty('name', null);
    paymentLineItem.defineProperty('item_type', PaymentLineItemType.Fee);
    paymentLineItem.defineProperty('sku', null);
    paymentLineItem.defineProperty('description', null);
    paymentLineItem.defineProperty('sort_order', workflowStep.nextPaymentLineItemSortOrder(), isNew);

    if (isNew) {
      PaymentLineItemAmountFactory.create(paymentLineItem);
    }

    if (isAttached) {
      paymentLineItem.parent = workflowStep;
      PaymentLineItem.repo.add(paymentLineItem);
      Vue.set(workflowStep.payment_line_items, paymentLineItem.client_id, paymentLineItem);
    }

    return paymentLineItem;
  }
}